import { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";
import GuiContext from "config/context/guiContext";

const PrivateRoute = () => {
  const { userData } = useContext(GuiContext);

  return userData.accounts ? <Outlet /> : <Navigate to="/login" />;
};

export default PrivateRoute;
